import { render, staticRenderFns } from "./price.vue?vue&type=template&id=5fd410e8&scoped=true"
import script from "./price.vue?vue&type=script&lang=js"
export * from "./price.vue?vue&type=script&lang=js"
import style0 from "./price.vue?vue&type=style&index=0&id=5fd410e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fd410e8",
  null
  
)

export default component.exports